import {Component, OnInit, ViewChild} from '@angular/core';
import { MAT_STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import {MatHorizontalStepper} from '@angular/material';
import {SignupProgressDataService} from './signup-progress-data.service';

@Component({
  selector: 'app-signup-progress',
  templateUrl: './signup-progress.component.html',
  styleUrls: ['./signup-progress.component.scss'],
  providers: [{
    provide: MAT_STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }]
})
export class SignupProgressComponent implements OnInit {
  constructor(public signUpdataService: SignupProgressDataService) { }

  ngOnInit() {
  }

  toggleClickExecutor(a) {
    $('.' + a).slideToggle();
  }

  getColor(status) {
    switch (status) {
      case 'initial':
        return 'black';
      case 'success':
        return 'green';
      case 'failed':
        return 'red';
    }
  }

}
